import { createApp } from "vue";
import App from "./App.vue";
import {
  Select,
  Button,
  InputNumber,
  Input,
  Modal,
  Popconfirm,
} from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

async function bootstrap() {
  const app = createApp(App);
  app.use(Select);
  app.use(Button);
  app.use(InputNumber);
  app.use(Input);
  app.use(Modal);
  app.use(Popconfirm);
  app.config.warnHandler = () => null;
  app.mount("#app");
}

bootstrap();
